import {ComponentStore} from '@ngrx/component-store';
import {Injectable} from '@angular/core';

export interface ResumeSlideState {
  newProduct: boolean;
}

const emptyState = (): ResumeSlideState => ({
  newProduct: false,
});

@Injectable({
  providedIn: 'root',
})
export default class ResumeSlideStore extends ComponentStore<ResumeSlideState> {
  public readonly newProduct$ = this.select(state => state.newProduct);

  public constructor() {
    super(emptyState());
  }

  public saveNewProduct(newProduct: boolean): void {
    this.patchState(() => ({newProduct}));
  }

  public syncNewProduct(): boolean {
    return this.get().newProduct;
  }

  public reset(): void {
    this.setState(() => emptyState());
  }
}
